import React, { useEffect, useRef } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

interface VideoPlayerProps {
  videoSrc: string
  poster?: string
  autoplay?: boolean
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoSrc, poster, autoplay }) => {
  const videoNode = useRef<HTMLVideoElement | null>(null)
  const playerRef = useRef<ReturnType<typeof videojs> | null>(null)

  useEffect(() => {
    if (videoNode.current) {
      playerRef.current = videojs(videoNode.current, {
        controls: true,
        preload: 'auto',
        autoplay: autoplay || false,
        poster: poster,
        responsive: true,
        fluid: true, // Rende il video responsivo
        sources: [
          {
            src: videoSrc,
            type: 'video/mp4',
          },
        ],
      })

      return () => {
        if (playerRef.current) {
          playerRef.current.dispose()
        }
      }
    }
  }, [videoSrc, poster, autoplay])

  return (
    <div data-vjs-player className='relative mx-auto w-full max-w-3xl'>
      <video ref={videoNode} className='video-js vjs-default-skin w-full rounded-lg shadow-lg' controls></video>
    </div>
  )
}

export default VideoPlayer
